import React from 'react';
import cn from 'classnames';

import styles from './IconButton.module.scss';

type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  'aria-label': string;
  className?: string;
  disabled?: boolean;
  tabIndex?: number;
  children: React.ReactNode;
};

const IconButton: React.FC<IconButtonProps> = ({
  'aria-label': ariaLabel,
  className,
  disabled,
  tabIndex,
  children,
  type = 'button',
  ...rest
}) => {
  return (
    <button
      aria-label={ariaLabel}
      className={cn(styles['icon-button'], className)}
      disabled={disabled}
      tabIndex={tabIndex}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
};

export default React.memo(IconButton);
